<section class="py-5 hero-gradient-cc-instructions">
  <div class="container">
    <div class="row gx-5">
      <div class="col-12 col-md-6 d-flex flex-column justify-content-center text-white">
        <h1 id="instructions-heading" class="text-white fw-bold h1">
          Download Creative Cloud Desktop
        </h1>
        <h1 class="text-white fw-bold h1">
        </h1>

        <p class="mt-3 text-white fs-5">
          To get started, download Creative Cloud Desktop.
          This is where applications are launched and updated,
          and where you can manage and share any assets
          you’ve created and stored to the Cloud.
        </p>

        <p class="mt-3 text-white fs-5">
          See the
          <a [routerLink]="['/adobe/creative-cloud']"
             class="text-white"
             fragment="acceptable-use">Acceptable Use</a>
          section for more details.
        </p>

      </div>

      <!-- Instructions List -->
      <div class="col-12 col-md-6 fs-5 my-5 my-md-4">
        <p class="fw-bold fs-5 text-white">To access Adobe CC All Apps Pro:</p>

        <!-- This mainly using custom styles for the list -->
        <ol class="instructions-list text-white ps-0">
          <li>
            <span>
              Visit
              <a href="https://adobe.com"
                 target="_blank"
                 class="text-white">
                adobe.com
              </a>
            </span>
          </li>
          <li>
            <span>
              Select Sign In in the upper right corner.
            </span>
          </li>
          <li>
            <span>
              Enter your University of Utah email (uNID&#64;umail.utah.edu) in the email address field and select Continue.
            </span>
          </li>
          <li>
            <span>
              You will be re-directed to the University of Utah authentication page. Enter your uNID and password.
            </span>
          </li>
          <li>
            <span>
              You will be taken to the Creative Cloud home page. Hover over your profile in the upper right hand corner.
            </span>
          </li>
          <li>
            <span>
              Select Install Creative Cloud App link, under the Quick Links section.
            </span>
          </li>
          <li>
            <span>
              Once the download has finished, it should open automatically. If it doesn’t, locate the file and launch it.
            </span>
          </li>
          <li>
            <span>
              For additional questions,
              contact Digital Learning Technologies at
              <a href="mailto:classhelp@utah.edu" class="text-white">
                classhelp&#64;utah.edu
              </a>
            </span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</section>
